import React, { Component } from 'react';
import {
  GanttComponent,
  Inject,
  Edit,
  Selection,
  Toolbar,
  ColumnsDirective,
  ColumnDirective,
  CriticalPath,
  DayMarkers,
  PdfExport,
} from '@syncfusion/ej2-react-gantt';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { projectNewData } from './data';
import MainGrafik from '../TradePlanner/Charts/MainGrafik';
interface IProps {}
interface IState {
  dropDownValue: any;
}
export default class Gant extends Component<IProps, IState> {
  private taskFields: object;
  private resourceFields: object;
  private editSettings: object;
  private splitterSettings: object;
  private projectStartDate: Date;
  private projectEndDate: Date;
  private gridLines: any;
  private toolbar: any;
  private timelineSettings: object;
  private labelSettings: object;
  private eventMarkerDay1: Date;
  private eventMarkerDay2: Date;
  private eventMarkerDay3: Date;
  private eventMarkerDay4: Date;
  private gantObj: GanttComponent;
  private condition: boolean = true;
  private dropDown: DropDownListComponent;
  constructor(props: IProps) {
    super(props);
    this.dropDown = new DropDownListComponent(props);
    this.state = {
      dropDownValue: [
        { id: '1', value: 2 },
        { id: '2', value: 3 },
        { id: '3', value: 4 },
        { id: '4', value: 5 },
      ],
    };
    this.dropDown.dataSource = this.state.dropDownValue;
    this.dropDown.width = '70px';
    this.taskFields = {
      id: 'TaskID',
      name: 'TaskName',
      startDate: 'StartDate',
      endDate: 'EndDate',
      duration: 'Duration',
      progress: 'Progress',
      dependency: 'Predecessor',
      child: 'subtasks',
      notes: 'info',
      resourceInfo: 'resources',
      work: 'Work',
    };
    this.resourceFields = {
      id: 'resourceId',
      name: 'resourceName',
    };
    this.editSettings = {
      allowAdding: true,
      allowEditing: true,
      allowDeleting: true,
      allowTaskbarEditing: true,
      showDeleteConfirmDialog: true,
    };
    this.splitterSettings = {
      columnIndex: 2,
    };
    this.projectStartDate = new Date('03/26/2019');
    this.projectEndDate = new Date('07/28/2019');
    this.gridLines = 'Both';
    this.toolbar = [
      'Add',
      'Edit',
      'Update',
      'Delete',
      'Cancel',
      'ExpandAll',
      'CollapseAll',
      'Indent',
      'Outdent',
      'Search',
      'PrevTimeSpan',
      'NextTimeSpan',
      'Outdent',
      'Indent',
      'ZoomIn',
      'ZoomOut',
      'ZoomToFit',
      'CsvExport',
      'PdfExport',
      'CriticalPath',
    ];
    this.timelineSettings = {
      topTier: {
        unit: 'Week',
        format: 'MMM dd, y',
      },
      bottomTier: {
        unit: 'Day',
      },
    };
    this.labelSettings = {
      leftLabel: 'TaskName',
      rightLabel: 'resources',
    };

    this.eventMarkerDay1 = new Date('4/17/2019');
    this.eventMarkerDay2 = new Date('5/3/2019');
    this.eventMarkerDay3 = new Date('6/7/2019');
    this.eventMarkerDay4 = new Date('7/16/2019');
    this.gantObj = new GanttComponent(props);
    this.state = {
      dropDownValue: [
        { id: '1', value: 2 },
        { id: '2', value: 3 },
        { id: '3', value: 4 },
        { id: '4', value: 5 },
      ],
    };
  }

  calculateClose() {
    if (this.condition) {
      this.gantObj.height = 'calc(-390px + 100vh)';
    } else {
      this.gantObj.height = 'calc(-90px + 100vh)';
    }
    this.condition = !this.condition;
  }
  render() {
    return (
      <div>
        <div>
          <MainGrafik />
        </div>
        (
        <div className='control-pane'>
          <div className='control-section'>
            <div
              style={{
                width: '150px',
                position: 'relative',
                top: 0,
                marginTop: '-35px',
              }}
            >
              <DropDownListComponent
                id='cloudexecution-event'
                dataSource={this.state.dropDownValue}
                placeholder='Select Event'
              />
            </div>
            <GanttComponent
              height='calc(-90px + 100vh)'
              id='Critical'
              dataSource={projectNewData}
              ref={(ref: GanttComponent) => (this.gantObj = ref)}
              treeColumnIndex={1}
              taskFields={this.taskFields}
              labelSettings={this.labelSettings}
              projectStartDate={this.projectStartDate}
              projectEndDate={this.projectEndDate}
              enableCriticalPath={true}
              editSettings={this.editSettings}
              dateFormat='dd/MM/yyyy HH:mm'
              toolbar={this.toolbar}
              taskType='FixedDuration'
              gridLines={'Both'}
              allowPdfExport={true}
              enablePersistence={false}
              dataBound={() => {
                this.gantObj.setSplitterPosition('60%', 'position');
              }}
            >
              <ColumnsDirective>
                <ColumnDirective field='TaskID' width='80'></ColumnDirective>
                <ColumnDirective
                  field='TaskName'
                  headerText='Job Name'
                  width='250'
                  clipMode='EllipsisWithTooltip'
                ></ColumnDirective>
                <ColumnDirective field='StartDate'></ColumnDirective>
                <ColumnDirective field='Duration'></ColumnDirective>
                <ColumnDirective field='Progress'></ColumnDirective>
                <ColumnDirective field='Predecessor'></ColumnDirective>
                <ColumnDirective field='Work'></ColumnDirective>
              </ColumnsDirective>
              <Inject
                services={[
                  Selection,
                  Toolbar,
                  CriticalPath,
                  Edit,
                  DayMarkers,
                  PdfExport,
                ]}
              />
            </GanttComponent>
          </div>
        </div>
        )
      </div>
    );
  }
}
